// extracted by mini-css-extract-plugin
export default {"loaderWrap":"b93gC3ECfYbkvdgn8X0d","loader":"rIEVoFq97GkcElA24Y3m"};